"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StackWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n"], ["\n  display: flex;\n  width: 100%;\n"])));
var InnerStackWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: row;\n  width: ", ";\n  flex-wrap: wrap;\n  display: flex;\n  margin-left: ", ";\n  margin-top: ", ";\n"], ["\n  justify-content: ", ";\n  align-items: ", ";\n  flex-direction: row;\n  width: ", ";\n  flex-wrap: wrap;\n  display: flex;\n  margin-left: ", ";\n  margin-top: ", ";\n"])), function (_a) {
    var justifyContent = _a.justifyContent;
    return justifyContent;
}, function (_a) {
    var alignItems = _a.alignItems;
    return alignItems;
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return "calc(100% + " + theme.spacing[spacing] + ")";
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return "-" + theme.spacing[spacing];
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return "-" + theme.spacing[spacing];
});
var Box = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-flex;\n  padding-left: ", ";\n  padding-top: ", ";\n"], ["\n  display: inline-flex;\n  padding-left: ", ";\n  padding-top: ", ";\n"])), function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return theme.spacing[spacing];
}, function (_a) {
    var theme = _a.theme, spacing = _a.spacing;
    return theme.spacing[spacing];
});
var InlineStack = function (_a) {
    var spacing = _a.spacing, children = _a.children, _b = _a.justifyContent, justifyContent = _b === void 0 ? 'flex-start' : _b, _c = _a.alignItems, alignItems = _c === void 0 ? 'stretch' : _c, rest = __rest(_a, ["spacing", "children", "justifyContent", "alignItems"]);
    return (react_1.default.createElement(StackWrapper, { spacing: spacing },
        react_1.default.createElement(InnerStackWrapper, __assign({ spacing: spacing }, rest, { justifyContent: justifyContent, alignItems: alignItems }), react_1.default.Children.map(children, function (child) {
            if (!child)
                return null;
            return react_1.default.createElement(Box, { spacing: spacing }, child);
        }))));
};
exports.default = InlineStack;
var templateObject_1, templateObject_2, templateObject_3;
